module.exports = __webpack_public_path__ + "img/mp_bg1.24cbf78e.png";